import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { fetchAuthTokenWithCompanyCode } from '@api/common/api.js'
import { useAuthStore } from '@store/common/useAuthStore.js'
import { Loading } from '@targetLoading'

export const AppInit = () => {
  const code = new URLSearchParams(location.search).get('companyCode')
  const setIsReady = useAuthStore((s) => s.setIsReady)

  useEffect(() => {
    const init = async () => {
      if (code) await fetchAuthTokenWithCompanyCode(code)
      setIsReady(true)
    }
    init()
  }, [])

  const isReady = useAuthStore((s) => s.isReady)
  if (!isReady) return <Loading />
  return <Outlet />
}
